import api from "./Api";

class TributacoesService {
  GetTributacoes(payload) {
    return api.get("/v1/tributacoes/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTributacoes(payload) {
    return api.post("/v1/tributacoes/", payload).then((response) => {
      return response.data;
    });
  }

  PutTributacoes(payload) {
    return api.put("/v1/tributacoes/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTributacoes(payload) {
    return api.delete("/v1/tributacoes/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTributacoesOData(payload) {
    return api.get("/OData/Tributacoes" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TributacoesService();
